<cjm-layout-container
	layoutType="full-width"
	classesMain="c-detail-footer__container"
	[preventSpacing]="['top', 'bottom']"
>
	<ng-container main>
		<ng-content></ng-content>
	</ng-container>
</cjm-layout-container>
